import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/digitalvalley.webp';
import screenshot_target from '../../../images/letterfunnel/davidconde.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="David Conde"
      firstname="David"
      companyname="Digital Valley"
      competition="Aventus en Yield Studio"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/davidconde.js